import React, { useEffect, useState} from "react";
import Header from '../components/Header';
import { BsInfoLg, BsHeadset } from "react-icons/bs";
import Product2 from "../components/Product2";
import Sheet from 'react-modal-sheet';
import { useAxios } from "../services/useAxios";
import { Link , useLocation ,useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function OrderHistoryDetail (){
    const { t } = useTranslation();

    let userInfo = {}
    if(localStorage.getItem("user")){
        userInfo =JSON.parse(localStorage.getItem("user")).data;
    }

    const [isOpen, setOpen] = useState(false);
    const [data, setData] = useState({});

    const [selerInfo, setSelerInfo] = useState({});
    let {id} = useParams();
    const [request] = useAxios();
    const lang = localStorage.getItem("language") || "ko";

    const fn_getBuyMileagePolicy= () => {
        if(data.buyMileagePolicy){
            if(data.buyMileagePolicy.accmlValueUnitCode === 'UNIT02'){
                const accmlVal = Math.round((data.orderDelivInfo.goodsAmount - data.orderDelivInfo.saleTotalAmount)  * (Number(data.buyMileagePolicy.accmlValue) / 100));
                return accmlVal;
            }else{
                return Number(data.buyMileagePolicy.accmlValue);
            }
        }else{
            return 0;
        }
    }

    const fn_getReviewMileagePolicy = () => {
        if(data.reviewMileagePolicy){
            if(data.reviewMileagePolicy.accmlValueUnitCode === 'UNIT02'){
                const accmlVal = Math.round((data.orderDelivInfo.goodsAmount - data.orderDelivInfo.saleTotalAmount)  * (Number(data.reviewMileagePolicy.accmlValue) / 100));
                return accmlVal;
            }else{
                return Number(data.reviewMileagePolicy.accmlValue);
            }
        }else{
            return 0;
        }
    }
    
    const fetchData = async () => {
       
        const response = await request.post("/app/mypage/getMyOrderDetailAPI", {
            orderNo: id,
            nationSeCode:lang
        });

        if(response.data.resultCode === 200){
            setData(response.data.result);          
            console.log(response.data.result);
        }
    };

    useEffect(() => {
        fetchData();
      }, []);
    return (
        <div>            
            <div className="backGround bgBlue"></div>
            <Header type="cart" pageTitle={t(`Message.my_order_hist_detail_order_dtl`)}/>

            <div className="pl20 pr20">
                {data.orderDelivInfo?(
                    <>
                <div className="ment">
                    <p>{t(`Message.my_order_hist_detail_order_dtl_msg1`)}</p>
                    <p>{t(`Message.my_order_hist_detail_order_dtl_msg2`)}</p>
                </div>

                <div className="dfColG32 mt12 pb40">
                    <ul className="ohdDateWr">
                        <li className="dfcsG12 date">
                            {data.orderDelivInfo.payMethod === 'card'?(
                                <>
                                <span>{t(`Message.my_order_hist_detail_pay_de`)}</span>
                                <p>{data.orderDelivInfo.paidAt}</p>
                                </>
                            ):(
                                <>
                                <span>입금일자</span>
                                <p>{data.vaInfo?.expr_tlml}</p>
                                </>
                            )}
                        </li>
                        <li className="dfcsG12 orderNum">
                            <span>{t(`Message.my_order_hist_detail_order_no`)}</span>
                            <p>{data.orderDelivInfo?.orderNo}</p>
                        </li>
                    </ul>


                    <div className="ohdCont">
                        <h3 className="tit">{t(`Message.my_order_hist_detail_order_goods`)}</h3>

                        {data.orderSelerList && data.orderSelerList.map((seler, index) => (
                        <div key={index}>
                        <div className="sellerInfo" >
                            <div className="dfsbG20">
                                <h3 className="tit">{seler.cmpnm}</h3>
                                <div className="dfceG8">
                                    <button 
                                        type="button" 
                                        className="btn2424 wgB cDisa"
                                        onClick={(e) => {
                                            e.preventDefault(); 
                                            e.stopPropagation(); 
                                            setSelerInfo(seler)
                                            setOpen(true);

                                        }}>
                                            <BsInfoLg />
                                    </button>
                                    <a href={"tel:"+seler.selerTelno} className="btn2424 wgB cDisa"><BsHeadset /></a>
                                </div>
                            </div>
                            <div className="ment">
                                <p>{t(`Message.my_order_hist_detail_order_goods_msg1`)}</p>
                                <p>{t(`Message.my_order_hist_detail_order_goods_msg2`)}</p>
                            </div>
                        </div>
                        

                        <div className="prodList">
                            {seler.orderDelivDetailList && seler.orderDelivDetailList.map((obj, index2) => (
                            <Product2 key={index2}
                                type="type6" 
                                disprice={"￦"+((!obj.orderAmount?0:obj.orderAmount)*(obj.orderQy)).toLocaleString('ko-KR')}
                                img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+(obj.goodsImageSn?obj.goodsImageSn:0)}
                                option1={obj.firstOptnValue}
                                prodName={obj.goodsNm}
                            />
                            ))}    
                           
                        </div>
                        </div>
                         ))}    
                    </div>


                    <div className="ohdCont">
                        <h3 className="tit">{t(`Message.my_order_hist_detail_dlvy_dest`)}</h3>
                        <div className="deliv">
                            <div className="adrInfo dfColG8">
                                <h3 className="fs14 fw600 cBlack">{data.orderDelivInfo.recptrNm}</h3>
                                <p className="fs14 fw500 cDisa">{data.orderDelivInfo.recptrCttpc}</p>
                                <p className="fs14 fw400 cBlack">({data.orderDelivInfo.recptrZip}) {data.orderDelivInfo.recptrBassAdres} {data.orderDelivInfo.recptrDetailAdres}</p>
                            </div>
                            <ul className="adiDt dfColG8">
                                <li className="dfcsG12">
                                    {data.orderDelivInfo.entrncPass?(
                                        <>
                                    <p>{t(`Message.my_order_hist_detail_front_pass`)}</p>
                                    <p>{data.orderDelivInfo.entrncPass}</p>
                                    </>
                                    ):null}
                                </li>
                                <li className="dfcsG12">
                                    {data.orderDelivInfo.dlvyMemo?(
                                        <>
                                    <p>{t(`Message.my_order_hist_detail_shipping_req`)}</p>
                                    <p>{data.orderDelivInfo.dlvyMemo}</p>
                                        </>
                                    ):null}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="ohdCont">
                        <h3 className="tit">{t(`Message.my_order_detail_payment_info_pay_info`)}</h3>
                        <div className="payInfo">
                            <ul className="dfColG8">
                                <li className="dfsbG12">
                                    <p className="fs15 fw700 cOrg">{t(`Message.my_order_detail_payment_info_order_amt`)}</p>
                                    <p className="fs15 fw700 cOrg">￦{(data.orderDelivInfo.lastSetleAmount?data.orderDelivInfo.lastSetleAmount:0).toLocaleString('ko-KR')}</p>
                                </li>
                                <li className="dfsbG12">
                                    <p>{t(`Message.my_order_detail_payment_info_goods_amt`)}</p>
                                    <p>￦{(data.orderDelivInfo.goodsAmount?data.orderDelivInfo.goodsAmount:0).toLocaleString('ko-KR')}</p>
                                </li>
                                <li className="dfsbG12">
                                    <p>{t(`Message.my_order_detail_payment_info_goods_sle_amt`)}</p>
                                    <p>-￦{(data.orderDelivInfo.saleTotalAmount?data.orderDelivInfo.saleTotalAmount:0).toLocaleString('ko-KR')}</p>
                                </li>
                                <li className="dfsbG12">
                                    <p>{t(`Message.my_order_detail_payment_info_coupon_sle_amt`)}</p>
                                    <p>-￦{(data.orderDelivInfo.couponDscntAmount?data.orderDelivInfo.couponDscntAmount:0).toLocaleString('ko-KR')}</p>
                                </li>
                                <li className="dfsbG12">
                                    <p>{t(`Message.my_order_detail_payment_info_mlg_use_amt`)}</p>
                                    <p>-￦{(data.orderDelivInfo.mlgUseAmount?data.orderDelivInfo.mlgUseAmount:0).toLocaleString('ko-KR')}</p>
                                </li>
                                <li className="dfsbG12">
                                    <p>{t(`Message.my_order_detail_payment_info_dlvy_amt`)}</p>
                                    <p>￦{(data.orderDelivInfo.dlvyCtAmount?data.orderDelivInfo.dlvyCtAmount:0).toLocaleString('ko-KR')}</p>
                                </li>
                            </ul>
                            {data.setleResult?(
                            <ul className="dfColG8">                               
                                <li className="dfsbG12">
                                    <p>{data.setleResult.cardInfo?.cardName} {data.setleResult.cardInfo?.cardNum}</p>
                                    <p>{data.setleResult.cardInfo?.cardQuota?data.setleResult.cardInfo?.cardQuota+"개월":t(`Message.my_order_detail_payment_info_pay_card_quota1`)}</p>
                                </li>
                                <li className="dfsbG12">
                                    <p>{t(`Message.my_order_detail_payment_info_pay_dt`)}</p>
                                    <p>{data.setleResult.paidAt}</p>
                                </li>
                            </ul>
                            ):null}
                        </div>
                    </div>
                    {userInfo.mberTy!=='B'?(
                    <div className="ohdCont">
                        <h3 className="tit">{t(`Message.my_order_detail_mileage_info_title`)}</h3>
                        <div className="mile">
                            <ul className="dfColG8">
                                <li className="dfsbG12">
                                    <p className="dfcsG4 cBlack fs13">{t(`Message.my_order_detail_mileage_info_buying_save`)} <span className="cDisa">({t(`Message.my_order_detail_mileage_info_buying_confirm_save`)})</span></p>
                                    <p className="fw600 cBlack fs13">{t(`Message.my_order_detail_mileage_info_buying_mlg` , {buyMileage : fn_getBuyMileagePolicy()})}</p>
                                </li>
                                <li className="dfsbG12">
                                    <p className="dfcsG4 cBlack fs13">{t(`Message.my_order_detail_mileage_info_review_save`)} <span className="cDisa">{t(`Message.my_order_detail_mileage_info_review_confirm_save`)}</span></p>
                                    <p className="fw600 cBlack fs13">{t(`Message.my_order_detail_mileage_info_review_mlg` , {accmlValue : fn_getReviewMileagePolicy()})}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    ):null}
                </div>
                </>
                 ):null}       
            </div>
                                    


            <Sheet isOpen={isOpen} onClose={() => setOpen(false)} className="bottomModal">
                <Sheet.Container>
                <Sheet.Header />
                <Sheet.Content>
                    <div className="setDateModal dfColG20">
                        <h3 className="tit">{t(`Message.my_order_hist_detail_seller_info`)}</h3>
                        <ul className="modalSellerInfo">
                            <li>
                                <p className="tit">{t(`Message.my_order_hist_detail_company`)}</p>
                                <p className="cont">{selerInfo.cmpnm}</p>
                            </li>
                            <li>
                                <p className="tit">{t(`Message.my_order_hist_detail_representative`)}</p>
                                <p className="cont">{selerInfo.rprsntvNm}</p>
                            </li>
                            <li>
                                <p className="tit">{t(`Message.my_order_hist_detail_email`)}</p>
                                <p className="cont">{selerInfo.selerEmail}</p>
                            </li>
                            <li>
                                <p className="tit">{t(`Message.my_order_hist_detail_brno`)}</p>
                                <p className="cont">{selerInfo.bizrno?.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3')}</p>
                            </li>
                            <li>
                                <p className="tit">{t(`Message.my_order_hist_detail_business_loc`)}</p>
                                <p className="cont">({selerInfo.zip}) {selerInfo.bassAdres} {selerInfo.detailAdres}</p>
                            </li>
                        </ul>
                    </div>
                    <div className="btnWr">
                        <button type="button" onClick={() => setOpen(false)} className="btn40 wgB cDisa">{t(`Message.common_close`)}</button>
                    </div>
                </Sheet.Content>
                </Sheet.Container>
                <Sheet.Backdrop onClick={() => setOpen(false)}/>
            </Sheet>
        </div>
    );
};